import { render, staticRenderFns } from "./TranslationMachine.vue?vue&type=template&id=3444517f&scoped=true&"
import script from "./TranslationMachine.vue?vue&type=script&lang=js&"
export * from "./TranslationMachine.vue?vue&type=script&lang=js&"
import style0 from "./TranslationMachine.vue?vue&type=style&index=0&id=3444517f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3444517f",
  null
  
)

export default component.exports